export default {

    /**
     * thông báo của ứng dụng (ví dụ thông báo hoàn thành tính giá, bảo trì,...)
     */
    Application: 0,

    /**
     * Thông báo ismac từ hệ thống
     */
    ISMAC: 1,

    /**
     * Thông báo nâng cấp hệ thống 
     */
    Upgrade: 2
}